import { ApiBlueprint } from "@backstage/frontend-plugin-api";
import { DefaultEntityPresentationApi } from "@backstage/plugin-catalog";
import { catalogApiRef, entityPresentationApiRef } from "@backstage/plugin-catalog-react";
import BusinessIcon from '@material-ui/icons/Business';
import CategoryIcon from '@material-ui/icons/Category';

export const entityPresentationApi = ApiBlueprint.make({
  name: 'entity-presentation',
  params: defineParams =>
    defineParams({
      api: entityPresentationApiRef,
      deps: { catalogApi: catalogApiRef },
      factory: ({ catalogApi }) => {
        return DefaultEntityPresentationApi.create({
          catalogApi: catalogApi,
          kindIcons: {
            area: BusinessIcon,
            module: CategoryIcon,
          },
        });
      },
    }),
});